import { css } from '@emotion/react';

const managerStyles = css`
    .manager {
        display: inline-block;
        padding: 5px;
    }
    .company {
        display: flex;
    }
    .managerImg {
        width: 212px;
    }
    .managerName {
        margin: 0;
    }
    .link {
        color: green;
        text-decoration: none;
        font-weight: bold;
        font-size: 0.8em;
    }
    .link-name {
        margin-left: 5px;
    }
    .companyImg {
        width: 185px;
        height: 185px;
    }
    .companyDetails {
        margin: 10px 0 0 15px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .companyName {
        font-weight: bold;
    }
    .companyDesc {
        width: 800px;
    }
    .margin-bottom-zero {
        margin-bottom: 0;
    }
    .experience-bar,
    .fund-bar {
        height: 40px;
        .label {
            height: 50%;
        }
        .starter {
            height: 50%;
            background-color: #5cd790;
        }

        .filler {
            height: 100%;
            background-color: #ededed;
        }
    }

    .fund-bar {
        .label {
            display: flex;
            justify-content: space-between;
        }
        .starter {
            background-color: #00a758;
        }
        .filler {
            background-color: #fff;
        }
    }

    .accordion-section {
        width: 100%;

        .accordion-icon {
            margin-right: 10px;
        }
    }
`;

export const thememanagerStyles = css`
    .manager {
        display: inline-block;
        padding: 5px;
        width: 100%;
    }

    .company {
        display: flex;
    }

    .managerImg {
        width: 100px;
        border-radius: 50%;
    }

    .managerName {
        margin: 0;
        font-size: var(--body-small-fontSize);
    }

    .link {
        color: var(--color-text-link);
        text-decoration: none;
        font-weight: bold;
        font-size: var(--body-small-fontSize);
    }

    .link-name {
        margin-left: 5px;
    }

    .companyImg {
        width: 185px;
        height: 185px;
    }

    .companyDetails {
        margin: 10px 0 0 15px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .companyName {
        font-weight: bold;
        font-size: var(--body-small-fontSize);
    }

    .companyDesc {
        width: 800px;
        font-size: var(--body-small-fontSize);
    }

    .margin-bottom-zero {
        margin-bottom: 0;
    }

    .experience-bar,
    .fund-bar {
        height: 40px;
        .label {
            height: 50%;
        }
        .starter {
            height: 50%;
            background-color: var(--color-primary-main);
        }

        .filler {
            height: 100%;
            background-color: var(--color-light-grey);
        }
    }

    .fund-bar {
        .label {
            display: flex;
            justify-content: space-between;
            border-left: 0.4px solid var(--color-primary-border);
        }
        .starter {
            background-color: var(--color-primary-main);
            border-left: 0.4px solid var(--color-primary-border);
        }
        .filler {
            background-color: var(--color-light-grey);
        }
    }

    .accordion-section {
        width: 100%;

        .accordion-icon {
            margin-right: 10px;
        }
    }
`;
export default managerStyles;
